<template>
    <div class="login-container">
        <el-form ref="loginForm" class="login-form" auto-complete="on" label-position="left">
            <div class="title-container">
                <h3 class="title">
                    관리자 로그인
                </h3>
            </div>
            <el-form-item>
        <span class="svg-container">
          <i class="el-icon-user-solid"></i>
        </span>
                <el-input
                        name="loginForm"
                        v-model="loginForm.mb_id"
                        type="text"
                        auto-complete="on"
                />
            </el-form-item>

            <el-form-item >
        <span class="svg-container">
          <i class="el-icon-lock"></i>
        </span>
                <el-input
                        name="mb_password"
                        v-model="loginForm.mb_password"
                        :type="passwordType"
                        auto-complete="on"
                        @keyup.enter.native="userLogin"
                />
                <span class="show-pwd" @click="showPwd">
          <i class="el-icon-view"></i>
        </span>
            </el-form-item>
            <div class="login_find_link_wrap text_center">
                <!-- <el-link type="info" @click="$router.push('/auth/findid')">
                  아이디 찾기
                </el-link>

                <el-link type="info" @click="$router.push('/auth/findpassword')">
                  비밀번호 찾기
                </el-link> -->
            </div>
            <el-button type="primary" style="width:100%;margin-bottom:10px;" @click="userLogin">
                로그인
            </el-button>
            <!-- <el-button type="primary" style="width:100%;margin-bottom:30px; margin-left: 0px;" @click="movePage(`/auth/regist`)">
              입점 신청하기
            </el-button> -->
        </el-form>
        <!-- <p class="copyright">Copyright 2019 DGMONG Inc., All rights reserved.</p> -->
    </div>
</template>

<script>
    import VuxAlert from '@/mixins/alertMixins';
    import localStorage from '@/mixins/localStorage'
    import {setAuthInHeader} from "@/api/request";

    export default {
        name: "Login",
        mixins: [ VuxAlert, localStorage ],
        data(){
            return{
                loginForm:{
                    mb_id : this.$route.query.mb_id ?  this.$route.query.mb_id : '',
                    mb_password : this.$route.query.mb_password ?  this.$route.query.mb_password : ''
                },
                passwordType: 'password',
                labelPosition: 'right',
                formLabelAlign: {
                    name: '',
                    region: '',
                    type: ''
                },
                passPath: ['/auth/regist', '/auth/findid', '/auth/findpassword', '/auth'],
            }
        },

        created(){
            //window.open("http://localhost:8080/mailcert?mailkey=Ke7KTgDBpGzchPCdJ4Mp80l9DQMDEOlY4Up9owdTSBQRgVQ7mdHW6A3qerhQOdiO&id=potential8@nate.com");
            if(this.$route.query.token){
                this.$localStorage.set('token',this.$route.query.token);
            }

        },
        mounted(){
            let token = this.$localStorage.get('token');
            if(token){
                this.$route.query.token = '';
                this.performAutoLogin(token);
            }else{
                //   this.$router.push('/auth');
            }
        },
        methods: {

            showPwd() {
                if (this.passwordType === 'password') {
                    this.passwordType = ''
                } else {
                    this.passwordType = 'password'
                }
            },
            movePage(url) {
                this.$router.push(url);
            },
            async userLogin() {
                // if(!this.$v.$invalid){
                // 이메일 주소와 비밀번호 validation 후
                let params = {
                    mb_id : this.loginForm.mb_id,
                    mb_password : this.loginForm.mb_password,
                    m_type : 'admin'
                };
                await this.$api.$auth.login(params)
                    .then((res) => { // 로그인 api 통신 후 결과 처리
                        let resultData = res.Data.Result;
                        if (resultData.Info.status) {
                            if(resultData.Info.status){ // 로그인 성공 후 토큰 저장 및 로그인 인증 처리
                                this.token = resultData.List;
                                // this.$localStorage.set('mb_level', resultData.Result.Info.mb_level);
                                this.$localStorage.set('token', this.token);
                                setAuthInHeader(this.token);
                                // this.$api.$handler.authHeader(this.token);
                                this.$router.push('/');
                            }else{ // 로그인 실패
                                this.createAlert({
                                    title: "알림",
                                    content: "이메일 또는 비밀번호가 일치하지 않습니다.</br> 확인 후 다시 로그인해주세요.",
                                    btnText: "확인"
                                });
                            }
                        }else{
                            this.createAlert({
                                title: "알림",
                                content: "이메일 주소 또는 비밀번호를 확인해주세요.</br> 확인 후 다시 로그인해주세요.",
                                btnText: "확인"
                            });
                        }
                    });
                // }
            },
        }
    }
</script>
